/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable require-await */
/* eslint-disable no-undef */
/* eslint-disable no-async-promise-executor */
/**
 * Created by bear on 17/08/03.
 * 埋点功能封装
 */
import { loadFile } from '../../util'

export default class Statpid {
  constructor() {
    this.opts = {}
    this.yaStat = null
    // 由于关闭了 YA2 抓取 error 的上报， 所以需要以下逻辑
    // 抓取错误，防止在 ie 内核弹出报错弹窗;
    const winOnError = window.onerror
    function onerror() {
      try {
        const ev = window.event
        console.error(ev.message)
        console.error(ev.error)
      } catch (error) {}
      return true
    }
    if (winOnError) {
      window.onerror = function(err) {
        winOnError(err)
        return onerror()
      }
    } else {
      window.onerror = onerror
    }
  }

  /**
   * 初始化新规范数据上报
   */
  initStat(options, initStatOptions) {
    return new Promise(async (resolve, reject) => {
      if (!window.YA2) {
        await loadFile({
          url: `/js/yadas.min.js`
        })
      }
      const defaultInitStatOptions = {
        loginout: true
      }
      options.ive = 'xunlei-ver-1.0.0'
      this.yaStat =
        this.yaStat instanceof YA2
          ? this.yaStat
          : new YA2(options, {
              statChannel: '//das-game-xunlei.yy.com/1.gif',
              initStatOptions: initStatOptions || defaultInitStatOptions
            })

      resolve()
    })
  }

  /**
   * 登录上报
   **/
  async loginStat(options) {
    // 新ya.js2.0

    this.sendStat(options)
  }

  /**
   * 点击上报
   **/
  async clickStat(options) {
    // 新ya.js2.0
    this.sendStat(options)
  }

  // 新ya.js2.0,统一就用sendStat
  async sendStat(options) {
    if (!options.pro) {
      options.pro = 'xl_web'
    }
    // 检测pro规范
    const proRex = /^xl_/
    const isXLPro = proRex.test(options.pro)
    if (options.pro && !isXLPro) {
      options.pro = `xl_${options.pro}`
    }
    this.opts.pro = this.opts.pro || options.pro
    await this.initStat(options)
    this.yaStat.sendStat(options)
  }

  /**
   * 迅雷盒子打开游戏
   **/
  async openXLNewWindow(options) {
    const isInThunderClient = () => {
      return isInThunderPC() || isInThunderBOX()
    }
    const isInThunderPC = () => {
      return /\s+Thunder/.test(window.navigator.userAgent)
    }
    const isInThunderBOX = () => {
      return /\s+XLGame/.test(window.navigator.userAgent)
    }
    const { url, title = '迅雷游戏中心', height = 812, width = 1610 } = options
    const isModal = false
    const scale = window.devicePixelRatio || 1
    // 设置弹框大小，根据业务需求设置
    const Wwidth = Math.floor(width / scale)
    const Wheight = Math.floor(height / scale)
    const WtaskBarName = title
    // 给标题栏留了30px，其他距离窗口边距都设置为0，此处根据自己产品需求设置
    const leftMargin = 0
    const rightMargin = 0
    const topMargin = 30
    const bottomMargin = 0
    const mapNative = undefined
    const onShowCallback = undefined
    const onCloseCallback = undefined
    const onBrowserEvent = undefined
    const alwaysOnTop = false
    const minimizable = undefined
    const menuOptions = undefined
    const nativeOptions = undefined
    const resizable = true
    const isTopLevel = true
    // eslint-disable-next-line no-unused-expressions
    native &&
      native.CallNativeFunction(
        'CreateIndependentWebWnd',
        url,
        title,
        isModal,
        Wwidth,
        Wheight,
        leftMargin,
        rightMargin,
        topMargin,
        bottomMargin,
        mapNative,
        onShowCallback,
        onCloseCallback,
        onBrowserEvent,
        alwaysOnTop,
        minimizable,
        menuOptions,
        nativeOptions,
        resizable,
        isTopLevel,
        WtaskBarName
      )
  }

  /**
   * 游戏上报
   **/
  gameStat(options) {
    const pro = this.opts.pro || options.pro || 'xl_web'
    const gameId = options.gameId
    const serverId = options.serverId
    const server_code = options.server_code
    const referrer = (options.eid || '').replace(/click\//i, '')
    // tslint:disable-next-line
    const referrer_desc = (options.eid_desc || '').replace('点击/', '')
    // 其它上报数据
    const ext = options.ext || ''
    const gameBoxList = window._SDKCommonConf.gameBoxList || []
    const isInThunderClient = () => {
      return isInThunderPC() || isInThunderBOX()
    }
    const isInThunderPC = () => {
      return /\s+Thunder/.test(window.navigator.userAgent)
    }
    const isInThunderBOX = () => {
      return /\s+XLGame/.test(window.navigator.userAgent)
    }
    // 迅雷客户端环境下, 才采取盒子游戏打开方式
    if (isInThunderClient()) {
      // 指定端游游戏, 使用详情页形式打开游戏
      let isGameBox = false
      for (let index = 0; index < gameBoxList.length; index++) {
        const element = gameBoxList[index]
        if (element == gameId) {
          isGameBox = true
          break
        }
      }
      const defaultReferfrom = 'pc_yy_game_box'
      const boxTitle = options.boxTitle || ''
      const href = isGameBox
        ? 'http://youxi.xunlei.com/gamedetail'
        : 'http://youxi.xunlei.com/gamerun'
      const referfrom = defaultReferfrom
      let url = href + '?gameid=' + gameId
      if (!isGameBox) {
        url += '&serverid=' + serverId
        url += '&pro=' + pro
        url += '&referrer=' + encodeURIComponent(referrer)
        url += '&referrer_desc=' + encodeURIComponent(referrer_desc)
      }
      if (ext) {
        url += '&' + ext
      }
      if (!ext.includes('referfrom=')) {
        url += '&referfrom=' + referfrom
      }
      const params = {
        url,
        title: boxTitle
      }
      this.openXLNewWindow(params)
    } else {
      const href = 'http://wan.xunlei.com/game-offical/'
      let url =
        href +
        gameId +
        '/play' +
        '?gameid=' +
        gameId +
        '&server_id=' +
        serverId +
        '&pro=' +
        pro +
        '&referrer=' +
        referrer +
        '&referrer_desc=' +
        encodeURIComponent(referrer_desc)
      if (server_code) {
        url += '&server_code=' + server_code
      }
      if (ext) {
        url += '&' + ext
      }
      window.open(url, '_blank')
    }
  }
}

// 兼容原有静态字段写法
Statpid.isLogined = undefined
